import React from 'react'

import ContentContainer from '../Commons/ContentContainer'

const Home = () => {
  return <ContentContainer maxWidth='xl'>Home</ContentContainer>
}

export default Home
